import { Controller } from "@hotwired/stimulus"
import { makeMatcher } from "../utils/text_match"

// Barre d'actions de masse de la vue détail des écritures FEC : sélection (tout /
// une à une), compteur, affichage des seuls champs utiles à l'opération choisie, et
// filtrage des lignes (texte libre ou doublons probables) pour retrouver une écriture
// dans un agrégat qui peut en compter plusieurs centaines.
export default class extends Controller {
  static targets = ["checkbox", "count", "operation", "field", "submit", "row", "filter", "onlyDupes", "visible"]

  connect() {
    this.operationChanged()
    this.refresh()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach((cb) => {
      if (this.isVisible(cb)) cb.checked = checked
    })
    this.refresh()
  }

  refresh() {
    const n = this.checkboxTargets.filter((cb) => cb.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasSubmitTarget) this.submitTarget.disabled = n === 0
  }

  operationChanged() {
    if (!this.hasOperationTarget) return
    const op = this.operationTarget.value
    this.fieldTargets.forEach((field) => {
      field.hidden = field.dataset.op !== op
    })
  }

  // Filtre les lignes du tableau. Une ligne masquée est aussi décochée, pour ne
  // jamais appliquer une action de masse à une écriture qu'on ne voit plus.
  filterRows() {
    const matcher = makeMatcher(this.hasFilterTarget ? this.filterTarget.value : "")
    const dupesOnly = this.hasOnlyDupesTarget && this.onlyDupesTarget.checked
    let visibles = 0

    this.rowTargets.forEach((row) => {
      const matchTexte = matcher(row.dataset.search || "")
      const matchDupe = !dupesOnly || row.dataset.doublon === "1"
      const visible = matchTexte && matchDupe
      row.hidden = !visible
      if (visible) {
        visibles += 1
      } else {
        const cb = row.querySelector("input[type=checkbox]")
        if (cb) cb.checked = false
      }
    })

    if (this.hasVisibleTarget) this.visibleTarget.textContent = visibles
    this.refresh()
  }

  isVisible(checkbox) {
    const row = checkbox.closest("tr")
    return !row || !row.hidden
  }
}
